import React from "react";
import { useSector } from "./SectorContext";

function CertSection() {
  const { certData, activeSector } = useSector();
  return (
    <section className="cert-section">
      <div className="cert-wrapper">
        {certData.map((cert) => (
          <div className="cert-card" key={`${cert.name}-${cert.year}`}>
            <a
              href={cert.certlink}
              className="cert-image-link"
              target="_blank"
              aria-label={`View and verify ${cert.name}`}
            >
              {" "}
              <img className="cert-image" src={cert.badgeimage} alt={cert.name} />
              <div className="cert-name">{cert.name}</div>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}

export default CertSection;
